import { Usps } from "@omni/types/components/product/productPage/usps.type";
import { Mapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { UspsContextProvider } from "@/components/Blocks/usps/context/usps.context";

type Props = {
    usps: Usps;
    className?: string;
    children: ReactNode;
};

export const Base = ({ usps, className, children }: Props) => {
    if (!usps?.length) return null;

    return (
        <UspsContextProvider usps={usps}>
            <section className={cn(className)}>
                <ul className={cn("tw:mb-0")}>
                    <Mapped array={usps}>{children}</Mapped>
                </ul>
            </section>
        </UspsContextProvider>
    );
};
